import { render, staticRenderFns } from "./BsmaList.vue?vue&type=template&id=3cfb4829&scoped=true"
import script from "./BsmaList.vue?vue&type=script&lang=js"
export * from "./BsmaList.vue?vue&type=script&lang=js"
import style0 from "./BsmaList.vue?vue&type=style&index=0&id=3cfb4829&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfb4829",
  null
  
)

export default component.exports